import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "col-md-1 control-label" };
const _hoisted_2 = { class: "col-md-9" };
const _hoisted_3 = ["placeholder"];
const _hoisted_4 = {
    key: 0,
    class: "error form-group__message"
};
const _hoisted_5 = { class: "modal-footer" };
const _hoisted_6 = ["disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", null, [
        _createVNode($setup["BModal"], {
            ref: "deleteCurrentUserModal",
            "no-footer": "",
            centered: "",
            "data-cy": "delete-current-user-modal",
            size: "lg",
            title: _ctx.$t('JTADM_LAYOUT_DELETE')
        }, {
            default: _withCtx(() => [
                _createElementVNode("div", null, [
                    _createElementVNode("strong", null, _toDisplayString(_ctx.$t('JTADM_USERS_SELF_DELETE')), 1),
                    _cache[3] || (_cache[3] = _createElementVNode("hr", null, null, -1)),
                    _createVNode($setup["BContainer"], { class: "delete" }, {
                        default: _withCtx(() => [
                            _createElementVNode("div", {
                                class: _normalizeClass(["form-group row", { 'form-group--error': $setup.error }])
                            }, [
                                _createElementVNode("label", _hoisted_1, _toDisplayString(_ctx.$t('JTADM_EMAIL')), 1),
                                _createElementVNode("div", _hoisted_2, [
                                    _withDirectives(_createElementVNode("input", {
                                        class: "form-control form__input",
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (($setup.confirmEmail) = $event)),
                                        "data-cy": "confirmation-email",
                                        type: "text",
                                        placeholder: _ctx.$t('JTADM_EMAIL'),
                                        onBlur: _cache[1] || (_cache[1] = ($event) => ($setup.blurred = true))
                                    }, null, 40, _hoisted_3), [
                                        [
                                            _vModelText,
                                            $setup.confirmEmail,
                                            void 0,
                                            { trim: true }
                                        ]
                                    ]),
                                    ($setup.blurred && $setup.error)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.$t('JTADM_INVALID_EMAIL_ADDRESS')), 1))
                                        : _createCommentVNode("", true)
                                ])
                            ], 2)
                        ]),
                        _: 1
                    })
                ]),
                _createElementVNode("footer", _hoisted_5, [
                    _createElementVNode("button", {
                        class: "btn btn-danger",
                        "data-cy": "confirm-delete",
                        disabled: $setup.error,
                        onClick: _withModifiers($setup.confirmedDelete, ["prevent"])
                    }, _toDisplayString(_ctx.$t('JTADM_DIALOG_BUTTON_DELETE')), 9, _hoisted_6),
                    _createElementVNode("button", {
                        class: "btn btn-info text-white",
                        onClick: _cache[2] || (_cache[2] = _withModifiers(($event) => ($setup.deleteCurrentUserModal?.hide()), ["prevent"]))
                    }, _toDisplayString(_ctx.$t('JTADM_CANCEL')), 1)
                ])
            ]),
            _: 1
        }, 8, ["title"])
    ]));
}
